import { inject, provide } from "vue";
import { defineStore } from "pinia";
import { userService } from "@/_services";

/* import axios from "axios";
import { apiServer } from "@/globalVars.js"; */

export const userStore = defineStore("user", {
  state: () => ({
    user: null,
    error: null,
    filtersPage: {},
    changedPassword: null,
    resetedPassword: null,
    linkRecover: null,
    newedUser: null,
    disableButton: false,
    deactivatedUsers: null,
    activatedUsers: null,
    forwadedPassword: null,
    reassignedVehicles: null,
    modifiedUser: null
  }),
  getters: {
    userSigned: (state) => {
      if (state.user == null) {
        let usr = localStorage.getItem("user");
        if (usr) {
          state.user = JSON.parse(usr);
        }
      }
      return state.user;
    },
    isAuthenticated: (state) => state.user != null,
  },
  actions: {
    authenticate(user) {
      this.error = null;
      userService.login(user.email, user.password)
      .then((results) => {
        this.user = results;
      })
      .catch((reason) => {
        this.error = reason;
      });
    },
    changePassword(body){
      userService.changePassword(body)
      .then((result)=> this.changedPassword= result )
      .catch((reason) => (this.error = reason));
    },
    getRecoverLink(body){
      this.linkRecover = null;
      userService.getEnlaceRecuperacion(body)
      .then((result)=> this.linkRecover= result )
      .catch((reason) => (this.error = reason));
    },
    resetPassword(req){
      userService.resetPassword(req.body, req.token)
      .then((result)=> this.resetedPassword= result )
      .catch((reason) => (this.error = reason));
    },
    newUser(body){
      this.disableButton = true
      userService.newUser(body)
      .then((result)=> {
        this.newedUser = result
        this.disableButton = false
      })
      .catch((reason) => {
        this.error = reason
        this.disableButton = false
      });
    },
    onDownloadFile(fileName){
      userService.onDownloadFile(fileName)
      .then((result)=> {
        this.templateFile = result
      })
      .catch((reason) => {
        this.error = reason
      });
    },
    deactivateUsers(body){
      this.error= null;
      this.deactivatedUsers = null
      userService.deactivate(body)
      .then((result)=> {
        this.deactivatedUsers = result
      })
      .catch((reason) => {
        this.deactivatedUsers = null
        this.error = reason
      });
    },
    activateUsers(body){
      this.error= null;
      this.activatedUsers = null
      userService.activate(body)
      .then((result)=> {
        this.activatedUsers = result
      })
      .catch((reason) => {
        this.activatedUsers = null
        this.error = reason
      });
    },
    forwardPassword(body){
      this.error= null;
      this.forwadedPassword = null
      userService.forwardPassword(body)
      .then((result)=> {
        this.forwadedPassword = result
      })
      .catch((reason) => {
        this.forwadedPassword = null
        this.error = reason
      });
    },
    reassignVehicles(items){
      this.error= null;
      this.reassignedVehicles = null
      this.disableButton = true
      userService.reassignVehicles(items)
      .then((result)=> {
        this.reassignedVehicles = result
        this.disableButton = false
      })
      .catch((reason) => {
        this.reassignedVehicles = null
        this.disableButton = false
        this.error = reason
      });
    },
    modifyUser(userId, body){
      this.error= null;
      this.modifiedUser = null
      this.disableButton = true
      userService.modifyUser(userId, body)
      .then((result)=> {
        this.modifiedUser = result
        this.disableButton = false
      })
      .catch((reason) => {
        this.modifiedUser = null
        this.disableButton = false
        this.error = reason
      });
    },
  },

});

function getUserStore() {
  let store = inject("userStore", null);
  if (store === null) {
    store = userStore();
    provide("userStore", store);
  }
  return store;
}

export const useUserStore = getUserStore;
